var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('TheHeader'),_c('Contact',{attrs:{"minimized":"true"}}),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }